import { useState } from 'react';
import { changePassword } from '../utils/api';
import { C } from '../utils/constants';

export const ChangePasswordModal = ({ onClose }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('New passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      await changePassword(currentPassword, newPassword);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '10px 14px',
    border: `1.5px solid ${C.border}`,
    borderRadius: 8,
    fontSize: '1rem',
    fontFamily: "'Nunito', sans-serif",
    color: C.brown,
    background: '#fff',
    boxSizing: 'border-box',
    outline: 'none',
  };

  const labelStyle = {
    display: 'block',
    fontSize: '0.85rem',
    fontWeight: 700,
    color: C.brown,
    marginBottom: 6,
    fontFamily: "'Nunito', sans-serif",
  };

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(61,31,2,0.45)',
          zIndex: 999,
        }}
      />

      {/* Modal */}
      <div style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: '#fff',
        borderRadius: 16,
        padding: '36px 32px',
        width: '100%',
        maxWidth: 420,
        zIndex: 1000,
        boxShadow: '0 16px 60px rgba(61,31,2,0.2)',
        boxSizing: 'border-box',
      }}>
        <h2 style={{
          fontFamily: "'Forum', serif",
          color: C.brown,
          fontSize: '1.4rem',
          margin: '0 0 24px',
        }}>
          Change Password
        </h2>

        {success ? (
          <div>
            <div style={{
              background: '#f0fdf4',
              border: '1.5px solid #86efac',
              borderRadius: 10,
              padding: '16px 20px',
              color: '#166534',
              fontSize: '0.95rem',
              marginBottom: 24,
              lineHeight: 1.6,
            }}>
              ✅ Password changed successfully!
            </div>
            <button
              className="btn-primary"
              onClick={onClose}
              style={{ width: '100%' }}
            >
              Done
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>Current Password</label>
              <input
                type="password"
                value={currentPassword}
                onChange={e => setCurrentPassword(e.target.value)}
                style={inputStyle}
                required
                autoComplete="current-password"
              />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                style={inputStyle}
                required
                autoComplete="new-password"
                placeholder="Minimum 8 characters"
              />
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={labelStyle}>Confirm New Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                style={inputStyle}
                required
                autoComplete="new-password"
              />
            </div>

            {error && (
              <div style={{
                background: '#fef2f2',
                border: '1.5px solid #fca5a5',
                borderRadius: 8,
                padding: '12px 16px',
                color: '#991b1b',
                fontSize: '0.9rem',
                marginBottom: 16,
              }}>
                {error}
              </div>
            )}

            <div style={{ display: 'flex', gap: 12 }}>
              <button
                type="button"
                className="btn-secondary"
                onClick={onClose}
                style={{ flex: 1 }}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn-primary"
                style={{ flex: 2 }}
                disabled={loading}
              >
                {loading ? 'Saving...' : 'Change Password'}
              </button>
            </div>
          </form>
        )}
      </div>
    </>
  );
};
